import { Injectable, inject } from '@angular/core';
import { Observable, BehaviorSubject, of } from 'rxjs';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
} from '@angular/common/http';
import { SpinnerService } from '../spinner/spinner.service';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PortalMenuService {
  private httpclient = inject(HttpClient);
  private spinner = inject(SpinnerService);

  menuList: any;
  menuReady: any;
  menuUrl = 'api/getMenu?partner=';
  private menuData = new BehaviorSubject({});
  private topMenuRendered = new BehaviorSubject(Boolean);
  constructor() {
    this.menuList = this.menuData.asObservable();
    this.menuReady = this.topMenuRendered.asObservable();
  }
  exportReports(partnerName): Observable<any> {
    return this.httpclient.get('api/exportReports?partner=' + partnerName, {
      responseType: 'blob',
    });
  }
  reOrderCategories(
    partnerName: string,
    newCategoryOrder: Array<string>,
  ): Observable<any> {
    return this.httpclient.post('api/reOrderCategory', {
      partnerName,
      newCategoryOrder,
    });
  }

  reOrderMainMenu(
    partnerName: string,
    categoryName: string,
    newMainMenuOrder: Array<string>,
  ): Observable<any> {
    return this.httpclient.post('api/reOrderMainMenu', {
      partnerName,
      categoryName,
      newMainMenuOrder,
    });
  }

  reOrderSubMenu(
    partnerName: string,
    categoryName: string,
    mainMenuName: string,
    newSubMenuOrder: Array<string>,
  ): Observable<any> {
    return this.httpclient.post('api/reOrderSubMenu', {
      partnerName,
      categoryName,
      mainMenuName,
      newSubMenuOrder,
    });
  }

  reOrderDashboardList(
    partnerName: string,
    categoryName: string,
    mainMenuName: string,
    subMenuName: string,
    newMenuItemsOrder: Array<string>,
  ): Observable<any> {
    return this.httpclient.post('api/reOrderDashboards', {
      partnerName,
      categoryName,
      mainMenuName,
      subMenuName,
      newMenuItemsOrder,
    });
  }
  public setMenuLoaded(result) {
    this.topMenuRendered.next(result);
  }
  public getRoles(partner): Observable<any> {
    return this.httpclient.get('api/getAllRoles?partner=' + partner);
  }

  public getDashboardVerticals(): Observable<any> {
    return this.httpclient.get('api/getDashboardVerticals');
  }
  public updateDashboardVertical(verticalObj: any): Observable<any> {
    return this.httpclient.post('api/updateDashboardVertical', verticalObj);
  }
  public deleteDashboardVertical(verticalObj: any): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'content-Type': 'application/json',
      }),
      body: verticalObj,
    };
    return this.httpclient.delete('api/deleteDashboardVertical', options);
  }
  public getDashboardPlatforms(): Observable<any> {
    return this.httpclient.get('api/getDashboardPlatforms');
  }
  public getDashboardTags(): Observable<any> {
    return this.httpclient.get('api/getDashboardTags');
  }
  public updateDashboardPlatform(platformObj: any): Observable<any> {
    return this.httpclient.post('api/updateDashboardPlatform', platformObj);
  }
  public deleteDashboardPlatform(platformObj: any): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'content-Type': 'application/json',
      }),
      body: platformObj,
    };
    return this.httpclient.delete('api/deleteDashboardPlatform', options);
  }
  public getAwsAccounts(): Observable<any> {
    return this.httpclient.get('api/listAWSAccounts');
  }
  public getPartnerMenu(partner): Observable<any> {
    return this.httpclient.post('api/getPartnerMenu', { partnerName: partner });
  }

  public getPartnerNonEmptyMenu(partner): Observable<any> {
    return this.httpclient.get('api/getNonEmptyMenu?partner=' + partner);
  }

  public getMainMenu(partner): Observable<any> {
    return this.httpclient.post('api/getMainMenu', { partnerName: partner });
  }
  public getSubMenu(partner, mainmenu): Observable<any> {
    return this.httpclient.post('api/getSubMenu', {
      partnerName: partner,
      mainMenuName: mainmenu,
    });
  }
  changeMainMenu(newMenuDetails) {
    return this.httpclient.post<any>('api/changeMainMenu', newMenuDetails);
  }
  public updateCategory(updateObj: any): Observable<any> {
    return this.httpclient.post<any>('api/updateReportCategory', updateObj);
  }
  public updateMainMenu(updateObj: any): Observable<any> {
    return this.httpclient.post<any>('api/updateMainMenu', updateObj);
  }
  public updateMainMenuIcon(updateObj: any): Observable<any> {
    return this.httpclient.post<any>('api/updateMainMenuIcon', updateObj);
  }
  public addReportCategory(updateObj: any): Observable<any> {
    return this.httpclient.post<any>('api/addReportCategory', updateObj);
  }
  public addReportMainMenu(updateObj: any): Observable<any> {
    return this.httpclient.post<any>('api/addMainMenu', updateObj);
  }
  public addReportSubMenu(updateObj: any): Observable<any> {
    return this.httpclient.post<any>('api/addSubMenu', updateObj);
  }
  public getReportCategories(partnerName: string) {
    let params = new HttpParams().set('partner', partnerName);
    return this.httpclient.get<any>('api/getReportCategories', { params });
  }

  public getReportMainmenus(categoryObj: any) {
    let params = new HttpParams()
      .set('partner', categoryObj.partnerName)
      .set('category', categoryObj.categoryName);
    return this.httpclient.get<any>('api/getCategoryMainMenu', { params });
  }

  public getReportSubmenus(categoryObj: any) {
    let params = new HttpParams()
      .set('partner', categoryObj.partnerName)
      .set('category', categoryObj.categoryName)
      .set('mainMenu', categoryObj.mainMenuName);
    return this.httpclient.get<any>('api/getSubmenuMainmenu', { params });
  }
  public updateSubMenu(updateObj: any): Observable<any> {
    return this.httpclient.post<any>('api/updateSubMenu', updateObj);
  }
  changeSubMenu(newMenuDetails) {
    return this.httpclient.post<any>('api/changeSubMenu', newMenuDetails);
  }
  mainMenuDelete(mainMenuDetails) {
    return this.httpclient.post<any>('api/deleteMainMenu', mainMenuDetails);
  }
  subMenuDelete(subMenuDetails) {
    return this.httpclient.post<any>('api/deleteSubMenu', subMenuDetails);
  }
  categoryDelete(categoryDetails) {
    return this.httpclient.post<any>(
      'api/deleteReportCategory',
      categoryDetails,
    );
  }
  updateDashboard(dashboardData): Observable<HttpResponse<any>> {
    return this.httpclient.post<any>('api/dashboardUpdate', dashboardData, {
      observe: 'response',
    });
  }
  addNewMainMenu(newMenuData) {
    return this.httpclient.post<any>('api/mainMenuAdd', newMenuData);
  }
  addNewSubMenu(newMenuData) {
    return this.httpclient.post<any>('api/subMenuAdd', newMenuData);
  }
  addNewDashboard(newMenuData): Observable<HttpResponse<any>> {
    return this.httpclient.post<any>('api/dashboardAdd', newMenuData, {
      observe: 'response',
    });
  }
  checkRlsEnabled(menu) {
    return this.httpclient.post<any>('api/checkRls', menu);
  }
  updatePublisherRlsNote(dashboardId, rlsNote) {
    const params = new HttpParams()
      .set('dashboardId', dashboardId)
      .append('note', rlsNote);
    return this.httpclient.post<any>('api/updateRlsNote', {}, { params });
  }
  deleteDashboard(reportData) {
    return this.httpclient.post<any>('api/dashboardDelete', reportData);
  }
  moveDashboard(reportData) {
    return this.httpclient.post<any>('api/moveDashboard', reportData);
  }
  searchDashboards1(partnerName, keywords, searchType) {
    const params = new HttpParams()
      .set('partner', partnerName)
      .set('searchType', searchType);
    return this.httpclient.post<any>('api/searchDashboard', keywords, {
      params,
    });
  }
  searchDashboards(keywords: any) {
    return this.httpclient.post<any>('api/searchDashboard', keywords);
  }
  public getMenuItems(partner, mainmenu, submenu): Observable<any> {
    return this.httpclient.post('api/getMenuItems', {
      partnerName: partner,
      mainMenuName: mainmenu,
      subMenuName: submenu,
    });
  }
  public getReports(partner, category, mainmenu, submenu): Observable<any> {
    return this.httpclient.post('api/getReports', {
      partnerName: partner,
      categoryName: category,
      mainMenuName: mainmenu,
      subMenuName: submenu,
    });
  }
  public getDashboardsTotype(
    partner,
    mainmenu,
    submenu,
    type,
  ): Observable<any> {
    return this.httpclient.post('api/getDashboardsTotype', {
      partnerName: partner,
      mainMenuName: mainmenu,
      subMenuName: submenu,
      dashboardType: type,
    });
  }

  public getAllPartners(): Observable<any> {
    return this.httpclient.get('api/getAllPartners');
  }

  public setMenuData(partner) {
    this.httpclient.get(this.menuUrl + partner).subscribe(
      (res) => {
        this.menuData.next(res);
        this.spinner.hide();
      },
      (err) => {
        this.spinner.hide();
      },
    );
  }

  public getAllPartnersDashboard(): Observable<any> {
    const url = `api/getAllPartnerDashboardDetails`;
    return this.httpclient.get(url);
  }

  public getDashboardDetails(dashboardId: string[]): Observable<any> {
    const url = `api/getDashboardDetails`;
    return this.httpclient.post(url, dashboardId);
  }

  public getDashboard(id: string, name: string): Observable<any> {
    let params = new HttpParams()
      .set('dashboardId', id)
      .set('dashboardName', name);
    const url = 'api/getDashboardDetails';
    return this.httpclient.get(url, { params });
  }
  validateDashboardId(dashboardId: string, awsAccount: string) {
    return this.httpclient
      .post(
        'api/validateDashboardId',
        { dashboardId, awsAccount },
        { responseType: 'text' },
      )
      .pipe(
        map((response: string) => {
          return response.trim();
        }),
        catchError((error) => {
          console.error('Error validating dashboard ID:', error);
          return of('invalid');
        }),
      );
  }
  public getDashboardPartnersRoles(
    dashboardId: string,
  ): Observable<Map<string, string[]>> {
    const url = `api/multiPartnerRoles?dashboardId=${dashboardId}`;
    return this.httpclient.get<Map<string, string[]>>(url);
  }
}
